var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"got-a-medal"},[_c('h1',[_vm._v(_vm._s(_vm.line1))]),_c('h2',[_vm._v(_vm._s(_vm.line2))]),_c('div',{staticClass:"end-h"},[_c('button',{on:{"click":function($event){return _vm.$emit('resolve')}}},[_vm._v("OK")])])])}
var staticRenderFns = []

export { render, staticRenderFns }